import { Input, InputProps } from '@overdose/components'
import { BaseMoney } from 'shared-types/src/commercetools'

export interface SearchInputProps
  extends Omit<InputProps, 'value' | 'defaultValue' | 'onChange'> {
  defaultValue: string | BaseMoney
  value?: string
  onChange?: (value: string, e: React.ChangeEvent<HTMLInputElement>) => void
}

export const SearchInput = ({
  defaultValue,
  value,
  onChange,
  ...props
}: SearchInputProps) => {
  const handleChange = (
    value: string,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange?.(value, e)
  }
  return (
    <Input
      {...props}
      value={value}
      defaultValue={defaultValue}
      onChange={handleChange}
    />
  )
}